import { useMutation, UseQueryResult } from '@tanstack/react-query';
import { resendKycFileCertifierInvitation } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

/** Resends a nominated certifier's invitation from the KYC review. */
export const useResendCertifierInvitation = (getKYCDataRequest: UseQueryResult) => {
	const tMipManage = useTranslationMipManage();

	return useMutation({
		mutationFn: resendKycFileCertifierInvitation,
		onSuccess: () => {
			void getKYCDataRequest.refetch();
			showToastV2({
				title: tMipManage('kyc.review.certification.resent', {
					defaultValue: 'Invitation sent to the certifier again',
				}),
				state: 'success',
			});
		},
		onError: () =>
			showToastV2({
				title: tMipManage('kyc.review.certification.resend_failed', {
					defaultValue: 'We could not resend the invitation. Try again.',
				}),
				state: 'error',
			}),
	});
};
